module.exports = __webpack_public_path__ + "media/images/white-caret-edad06b37e512e54b5d69642bb442da8.svg";